import React from 'react'

import Base from '../_Base'

const Universal14 = (props) => (
  <Base width="38" height="22" viewBox="0 0 38 22" fill="none" {...props}>
    <path
      d="M3.701 1.642A2 2 0 0 1 5.67 0h29.935a2 2 0 0 1 1.967 2.358l-3.272 18A2 2 0 0 1 32.33 22H2.396A2 2 0 0 1 .43 19.642l3.272-18Z"
      fill="#4A4E58"
      fillOpacity=".7"
    />
    <path
      d="M12.365 6.818 10.675 17H8.83l1.392-8.387h-.06l-2.635 1.521.279-1.69 2.804-1.626h1.755ZM13.394 15.11l.239-1.466 5.453-6.826h1.223l-.348 2.088h-.74l-3.68 4.609-.01.08h6.036l-.253 1.516h-7.92ZM17.933 17l.388-2.342.134-.65 1.188-7.19h1.74L19.693 17h-1.76ZM25.885 15.36l1.133-6.881h1.566l-1.138 6.88h-1.561Zm-2.227-2.66.263-1.556h6.88l-.263 1.556h-6.88Z"
      fill="#BBB"
    />
  </Base>
)

export default Universal14
